import { SortOrder } from "../types";
import { SORT_KEY } from "./constants";
import { get, set } from "./get-set";

export const getSortOrder = () => {
  const existingData = get();

  const sortStored = existingData || { [SORT_KEY]: "ShudderSortOrder" };

  return sortStored[SORT_KEY];
};

export const saveSortOrder = (order: keyof typeof SortOrder) => {
  const existingData = get();

  const sortStored = existingData || { [SORT_KEY]: "ShudderSortOrder" };

  const modifiedData = { ...sortStored, [SORT_KEY]: order };

  set(modifiedData);
  return modifiedData;
};
